import React, { useState } from 'react';
import {
  Typography,
} from '@npm-registry/eapteka-ui';

import { onAcceptApprovals } from './helpers/onAcceptApprovals';

import Info from './Info';
import BannerModal from './BannerModal';
import Informer from './Informer';
import './bannerRecipe.scss';

const BannerRecipe = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [isAccepted, setAccepted] = useState(false);
  const [hasError, setError] = useState(false);
  const userIsLogged = localStorage.getItem('user-token') !== null;
  
  const errorMessage = (<span>
    <Typography variant='p2' weight='strong'>Технический сбой</Typography>
    <Typography variant='p3'>Попробуйте обновить или вернитесь позднее</Typography>
  </span>);
  const acceptedMessage = (<span>
    <Typography variant='p3'>Теперь вы&nbsp;можете получать доставку рецептурных лекарств на&nbsp;дом. Для этого оформите у&nbsp;врача электронный рецепт</Typography>
  </span>);
  
  const onReloadPage = () => window.location.reload();
  const onOpenInfoModal = () => setModalVisible(true);
  const onCloseInfoModal = () => setModalVisible(false);
  const onSubmit = async () => {
    document.body.classList.add('ajax-container', 'is-loading');

    try {
      const { result = false } = await onAcceptApprovals();

      if (result) {
        setAccepted(true);
        document.body.classList.remove('ajax-container', 'is-loading');
      } else {
        setError(true);
        document.body.classList.remove('ajax-container', 'is-loading');
      }
    } catch (error) {
      setError(true);
      document.body.classList.remove('ajax-container', 'is-loading');
    }
  };
  
  return  (userIsLogged) ? (
    <div className='BannerRecipe_Root'>
      {hasError ? (
        <Informer
          text={errorMessage}
          onClick={onReloadPage}
        />
      ) : isAccepted ? (
        <Informer
          text={acceptedMessage}
        />
      ) : (
        <>
          <Info
            onOpenInfoModal={onOpenInfoModal}
            onClick={onSubmit}
          />
          <BannerModal
            isShow={isModalVisible}
            handleClose={onCloseInfoModal}
          />
        </>
      )}
    </div>
  ) : null;
};

export default BannerRecipe;
